module.exports = __webpack_public_path__ + "img/1728437838329-Screenshot_9-10-2024_9376_www.instagram.com.jpeg.8bbb961b.webp";